module.exports = __webpack_public_path__ + "static/img/mouse.258ef6e4.png";